import { Button, Col, Dropdown, Layout, List, Menu, Popover, Row, Space, Typography } from 'antd';
import { AppLogo, Icon } from 'components';
import React from 'react';
import {
  AiOutlineDown,
  AiOutlineInfoCircle,
  AiOutlineLogout,
  AiOutlineQuestionCircle,
  AiOutlineUser,
} from 'react-icons/ai';
import { NavLink } from 'react-router-dom';
import { accountLogout } from 'services/auth';
import { version } from '../../../package.json';

const styles = {
  h2: {
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: '-0.02em',
    marginBottom: 0,
  },
  header: {
    boxShadow: '0 -1px 0 0 #e1e3e6 inset',
  },
  logoBox: {
    marginBottom: 16,
    padding: '16px 32px',
    border: '1px solid #eeeeee',
    borderRadius: 4,
  },
  logo: {
    marginBottom: -4, // for inline-element 4px
  },
  title: {
    marginBottom: 0,
    letterSpacing: '-0.04em',
    color: 'rgba(0, 0, 0, 0.85)',
    fontWeight: 700,
    fontSize: 22,
    lineHeight: 1,
  },
};

const AppInfo = () => {
  return (
    <div>
      <div style={styles.logoBox}>
        <AppLogo width={120} />
      </div>
      <List size="small" bordered={false}>
        <List.Item>
          <strong>VD-i v2.0 (rev. 20211104)</strong>
        </List.Item>
        <List.Item>vsportal {version}</List.Item>
      </List>
    </div>
  );
};

const AccountMenu = () => {
  return (
    <Menu>
      <Menu.Item key="myinfo" icon={<AiOutlineInfoCircle />}>
        <NavLink to="/myInfo">내 정보</NavLink>
      </Menu.Item>
      <Menu.Item
        key="logout"
        icon={<AiOutlineLogout />}
        onClick={async () => {
          await accountLogout();
        }}
      >
        로그아웃
      </Menu.Item>
    </Menu>
  );
};

function AppHeader({ user, history, currentPage }) {
  return (
    <Layout.Header style={styles.header}>
      <Row align="middle" justify="space-between">
        <Col>
          <Typography.Title level={2} style={styles.h2}>
            {currentPage}
          </Typography.Title>
        </Col>
        <Col>
          <Space>
            <Popover title="앱 정보" content={<AppInfo />}>
              <Button type="link" icon={<Icon name={<AiOutlineQuestionCircle />} />} />
            </Popover>
            <Dropdown overlay={() => <AccountMenu history={history} />}>
              <Button type="link" icon={<Icon name={<AiOutlineUser />} />}>
                <span>{user}</span>
                <Icon name={<AiOutlineDown />} />
              </Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>
    </Layout.Header>
  );
}

export default AppHeader;
